import {getEditableFieldConfiguration} from "../editable-field.component";
import {IEditableField} from "../IEditableField";


export class EnumEditableFieldComponent extends IEditableField {
    static instance = getEditableFieldConfiguration(
        require('./enum-editable-field.component.html'),
        [EnumEditableFieldComponent],
        {
            enumValues: '<'
        }
    );

    private enumValues: string[];

    $onInit(): void {
        this.errorMessage = this.getErrorMessage();
    }


    private getErrorMessage() {
        let errorMessage = this.enumValues.reduce(
            (prevV: string, currentValue: string) => {
                return prevV + currentValue + ", ";
            },
            "Value should be one of this: ");
        return errorMessage.substring(0, errorMessage.length - 2);
    }
}